// import logo from './logo.svg';
import './App.css';
// import Header from './dist/Component/Header';
import '../src/dist/scss/main.scss'
import  { BrowserRouter as Router,Routes, Route } from 'react-router-dom';
import Home from './dist/Component/Home';
import ConnectWallet from './dist/Component/ConnectWallet';
import Bnbs from './dist/Component/Bnbs';
import Community from './dist/Component/Community';
import NFTs from './dist/Component/NFTs';
import Header from './dist/Component/Header';
import Footer from './dist/Component/Footer';


function App() {
  return (
    <div className= "">
      <Router>
         <Header/>
      
         <Routes>
         <Route path="/" element={ <Home/>}/>
         <Route path="/Bnbs" element={<Bnbs/>}/>
         <Route path="/NFTs" element={<NFTs/>}/>
         <Route path="/Community" element={<Community/>}/> 
         <Route path="/ConnectWallet" element={<ConnectWallet/>}/>
 
         </Routes>

         <Footer/>
 
       </Router>

       
      
    </div>
  );
}

export default App;
